import '../../../../assets/css/screens/admin/dashboard/platformvideos/PlatformVideos.css';
import React, { useState, useEffect , useContext} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import {
PlusCircle, Video,
Star, Trash2, Play, X, Home, Info
} from 'lucide-react';
import AddVideoModal from "../../../../components/admin/dashboard/addvideomodal/AddVideoModal";




const SECTIONS = [
  { key: 'hero', label: 'Hero Section', icon: Home },
  { key: 'about', label: 'About Us', icon: Info },
];


const PlatformVideos = () => {
    const { baseUrl, authToken, baseUrlForFile } = useContext(AppContext);

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeSectionTab, setActiveSectionTab] = useState('hero');
  const [showAddModal, setShowAddModal] = useState(false);
  const [previewVideo, setPreviewVideo] = useState(null);



  /* ── fetch all platform videos ── */
  const fetchVideos = () => {
    setLoading(true);

 const token = localStorage.getItem("token");

axios.get(`${baseUrl}/admin/view/videos`, {
    headers:{
        Authorization:`Bearer ${authToken}`
    }
})
.then((res)=>{
    setVideos(res.data.videos || []);
})
.catch((err)=>{
    console.log(err.response?.data || err.message);
})
.finally(()=>setLoading(false));
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  /* ── after successful upload ── */
  const handleUploaded = (newVideo) => {
    setVideos((prev) => {
      // is section+device ka jo pehle active tha usko inactive kar do (frontend state)
      const updated = prev.map((v) =>
v.section === newVideo.section
                ? { ...v, active: false }
          : v
      );
      return [...updated, newVideo];
    });
    setShowAddModal(false);
  };

  /* ── set a video active (within its section+device group) ── */
  const handleSetActive = (video) => {

axios.post(
`${baseUrl}/admin/setactive/video/${video.id}`,
{},
{
headers:{
Authorization:`Bearer ${localStorage.getItem("authToken")}`
}
}
)
      .then(() => {
        setVideos((prev) =>
          prev.map((v) => {
           if (v.section === video.section) {
              return { ...v, active: v.id === video.id };
            }
            return v;
          })
        );
        Swal.fire({ icon: 'success', title: 'Active Video Updated', timer: 1600, showConfirmButton: false });
      })
      .catch((err) => {
        Swal.fire({ icon: 'error', title: 'Failed', text: err.response?.data?.message || 'Could not update.' });
      });
  };

  /* ── delete video ── */
  const handleDelete = (video) => {
    Swal.fire({
      title: 'Delete this video?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#ef4444',
    }).then((result) => {
      if (!result.isConfirmed) return;

      


axios.delete(`${baseUrl}/admin/delete/video/${video.id}`,{
    headers:{
        Authorization:`Bearer ${localStorage.getItem("authToken")}`
    }
})
        .then(() => {
          setVideos((prev) => prev.filter((v) => v.id !== video.id));
        })
        .catch((err) => {
          Swal.fire({ icon: 'error', title: 'Failed', text: err.response?.data?.message || 'Could not delete.' });
        });
    });
  };

  const sectionVideos = videos.filter((v) => v.section === activeSectionTab);
  const hasAnyVideos = videos.length > 0;

  const getVideoUrl = (file) => (file?.startsWith('http') ? file : `${baseUrlForFile}/${file}`);

  return (
    <div className="pv-page">

      {/* Heading */}
      <div className="pv-heading">
        <div>
          <h2 className="pv-heading__title">Platform Videos</h2>
          <p className="pv-heading__sub">Manage Hero Section & About Us videos across all screen sizes</p>
        </div>

        {hasAnyVideos && (
          <button className="pv-add-btn" onClick={() => setShowAddModal(true)}>
            <PlusCircle size={17} /> Add Video
          </button>
        )}
      </div>

      {/* Section Tabs */}
      <div className="pv-tabs">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          const count = videos.filter((v) => v.section === s.key).length;
          return (
            <button
              key={s.key}
              className={'pv-tab' + (activeSectionTab === s.key ? ' pv-tab--active' : '')}
              onClick={() => setActiveSectionTab(s.key)}
            >
              <Icon size={16} /> {s.label}
              <span className="pv-tab__count">{count}</span>
            </button>
          );
        })}
      </div>

      {/* Content */}
      {loading ? (
        <div className="pv-empty-state">
          <div className="pv-empty-state__spinner" />
          <p>Loading videos...</p>
        </div>
      ) : !hasAnyVideos ? (
        /* ── NO VIDEOS AT ALL — big center button ── */
        <div className="pv-empty-state">
          <div className="pv-empty-state__icon"><Video size={34} /></div>
          <h3>No videos added yet</h3>
          <p>Add your first video for the Hero Section or About Us page.</p>
          <button className="pv-empty-state__btn" onClick={() => setShowAddModal(true)}>
            <PlusCircle size={18} /> Add Video
          </button>
        </div>
      ) : (
        /* ── DEVICE GROUPS FOR SELECTED SECTION ── */
     <div className="pv-video-grid">

{
sectionVideos.length === 0 ? (

<div 
className="pv-device-group__empty"
onClick={()=>setShowAddModal(true)}
>
<PlusCircle size={22}/>
<span>Add Video</span>
</div>

) : (

sectionVideos.map((v)=>(

<div 
key={v.id}
className={
'pv-video-card' + 
(v.active ? ' pv-video-card--active':'')
}
>

<div 
className="pv-video-card__thumb"
onClick={()=>setPreviewVideo(v)}
>

<video
src={getVideoUrl(v.file)}
className="pv-video-card__video"
muted
/>


<div 
className={`pv-active-toggle ${v.active ? 'active' : ''}`}
onClick={(e)=>{
 e.stopPropagation();
 handleSetActive(v);
}}
>
<span></span>
</div>


<div className="pv-video-card__play-overlay">
<Play size={20}/>
</div>


</div>


<div className="pv-video-card__footer">

<span className="pv-video-card__name">
{v.name || `Video #${v.id}`}
</span>


<div className="pv-video-card__actions">





<button
className="pv-icon-btn pv-icon-btn--delete"
onClick={()=>handleDelete(v)}
>
<Trash2 size={14}/>
</button>


</div>

</div>

</div>

))

)
}


<button 
className="pv-video-add-card"
onClick={()=>setShowAddModal(true)}
>
<PlusCircle size={22}/>
<span>Add More</span>
</button>


</div>
      )}

      {/* Add Video Modal */}
      {showAddModal && (
        <AddVideoModal
          onClose={() => setShowAddModal(false)}
          onUploaded={handleUploaded}
          baseUrl={baseUrl}
          defaultSection={activeSectionTab}
        />
      )}

      {/* Preview Lightbox */}
      {previewVideo && (
        <div className="pv-lightbox" onClick={() => setPreviewVideo(null)}>
          <button className="pv-lightbox__close" onClick={() => setPreviewVideo(null)}>
            <X size={22} />
          </button>
          <video
            src={getVideoUrl(previewVideo.file)}
            className="pv-lightbox__video"
            controls
            autoPlay
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

    </div>
  );
};

export default PlatformVideos;